export const TRANSLATE_KEY = {
  createNewGroup: 'dialog.create_new_group',
  editGroup: 'dialog.edit_group',
  group: 'dialog.group',
  groupName: 'dialog.group_name',
  chooseColor: 'dialog.choose_color',
  chooseShape: 'dialog.choose_shape',
  deleteGroup: 'dialog.delete_group',
};
